/**
 * Pre-compiled fr-FR messages for Drawer
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Fermer le volet` };
